// the transition duration stateMap.animDur is half of the transition duration set in lay options, because
// whole animation duration = fadeout duration + fadein duration

var stateMap = {
	animationTimer: null,
	animationInterval: null,
	animDur: 300,
}

var startTimer = function () {
	stateMap.animationTimer = 0
	clearInterval(stateMap.animationInterval)
	stateMap.animationInterval = setInterval(function () {
		stateMap.animationTimer += 50
		if (stateMap.animationTimer >= stateMap.animDur) {
			window.laytheme.emit('content_fadeout_transition_ended')
			clearInterval(stateMap.animationInterval)
		}
	}, 50)
}

var completeTimer = function () {
	stateMap.animationTimer = stateMap.animDur
	clearInterval(stateMap.animationInterval)
	window.laytheme.emit('content_fadeout_transition_ended')
}

var getTimeToWait = function () {
	clearInterval(stateMap.animationInterval)
	if (stateMap.animationTimer >= stateMap.animDur || elements_transition_ended) {
		return 0
	} else {
		return stateMap.animDur - stateMap.animationTimer
	}
}
var i = function () {
	// the transition duration needs to be half of the transition duration set in lay options, because
	// whole animation duration = fadeout duration + fadein duration
	stateMap.animDur = parseInt(layData.navigation_transition_duration, 10) / 2
	window.laytheme.on('transition_navigation_in_started', function () {
		elements_transition_ended = false
	})
	window.laytheme.on('transition_navigation_out_completed', function () {
		elements_transition_ended = true
	})
}

var elements_transition_ended = false

var transition_timer_controller = {
	i: function () {
		i()
	},
	startTimer: function () {
		startTimer()
	},
	completeTimer: function () {
		completeTimer()
	},
	hasElementTransitionEnded: function () {
		return elements_transition_ended
	},
	getTimeToWait: function () {
		return getTimeToWait()
	},
}

export { transition_timer_controller }
